module.exports = __webpack_public_path__ + "img/2-1_09.6786f008.jpg";